import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

export const routes: Routes = [
  {
    path: "list",
    loadChildren: () =>
      import("./bundles/requests/requests.module").then(
        (m) => m.RequestsModule,
      ),
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "list",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      onSameUrlNavigation: "reload",
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
